/* @ngInject */

export default (
  $rootScope,
  $scope,
  webpage,
  eventService,
  checklistService,
  checklistsService,
  actionService
) => {
  $scope.Model = {
    availableChecklists: [],
    checklistsList: null,
    watcher: null,
    isArchive: false,
    isReady: false
  };

  /*
   * Initialize controller and start loading the required data
   * --------------------------------------------------------------------------------
   */
  const loadChecklists = () => {
    webpage.pageTitle('Loading, please wait');
    checklistsService
      .getAvailable({ isActive: !$scope.Model.isArchive })
      .then((data) => {
        // Set Model values
        $scope.Model.availableChecklists = data;
      })
      .then(() => {
        // Declare Model as Ready and start rendering the page
        webpage.pageTitle('Required documents : Settings');
        $scope.Model.isReady = true;
      });
  };

  if ($rootScope.CurrentAccount.isAdministrator) {
    loadChecklists();
  }

  /*
   * Events available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.$on('checklistDelete', () => {
    checklistsService.clearCache();
    actionService.deleteDocuments(
      $scope.Model.checklistsList.getSelected(),
      checklistService.deleteChecklist,
      $scope.Model.checklistsList.removeData,
      'required document(s)'
    );
  });

  $scope.$on('checklistDuplicate', () => {
    checklistsService.clearCache();
    actionService.duplicateDocuments(
      $scope.Model.checklistsList.getSelected(),
      checklistService.readChecklist,
      checklistService.createChecklist,
      $scope.Model.checklistsList.setDataAppend,
      'name',
      ' copy',
      'required document(s)'
    );
  });

  $scope.$on('checklistActivate', () => {
    checklistsService.clearCache();
    actionService.toggleDocuments(
      $scope.Model.checklistsList.getSelected(),
      checklistService.updateChecklist,
      $scope.Model.checklistsList.removeData,
      'required document(s)',
      true
    );
  });

  $scope.$on('checklistArchive', () => {
    checklistsService.clearCache();
    actionService.toggleDocuments(
      $scope.Model.checklistsList.getSelected(),
      checklistService.updateChecklist,
      $scope.Model.checklistsList.removeData,
      'required document(s)',
      false
    );
  });

  $scope.$on('checklistAdd', (e, $event) => {
    checklistsService.clearCache();
    eventService.checklistEdit({
      event: $event,
      checklist: null,
      list: $scope.Model.checklistsList
    });
  });

  /*
   * Methods available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.checklistEdit = ($event, checklist) => {
    eventService.checklistEdit({
      event: $event,
      checklist,
      list: $scope.Model.checklistsList
    });
  };

  $scope.checklistEdited = (checklistEdited) => {
    const checklist = checklistEdited;
    checklistsService.clearCache();
    if (checklist.isNew === true) {
      delete checklist.isNew;
      if (checklist.isActive !== $scope.Model.isArchive) {
        $scope.Model.checklistsList.setDataAppend(checklist);
      }
    } else {
      $scope.Model.checklistsList.setDataReplace(checklist);
    }
  };

  $scope.listChange = function (list, data, isSelected) {
    $scope.$parent.Model.childStateHasSelection = isSelected || list.isSelectedAny();
  };

  $scope.listReady = function (list) {
    $scope.Model.checklistsList = list;
    $scope.Model.watcher = $scope.$parent.$watch(
      'Model.childStateIsArchive',
      (newValue, oldValue) => {
        if (newValue !== oldValue) {
          $scope.Model.isArchive = newValue;
          $scope.Model.isReady = false;
          $scope.Model.watcher();
          loadChecklists();
        }
      }
    );
  };
};
